export default "__VITE_ASSET__DRiXXM7k__"